import './Header.scss'
// import { BsBoxArrowInLeft, BsBoxArrowInRight } from "react-icons/bs";
import {  IoMdNotificationsOutline, IoIosNotifications } from "react-icons/io";
import { IoHomeOutline, IoMenuSharp } from "react-icons/io5";
import { MdOutlineSpeakerNotes, MdEventAvailable } from "react-icons/md";
import { BsBoxArrowInLeft, BsBoxArrowInRight, BsChatDots } from "react-icons/bs";
import { CgProfile } from "react-icons/cg";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { useEffect, useState } from 'react';
import { Link,  Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Calender1 from '../calender/Calender1'
import Calender from '../calender/Calender';
import { motion } from "framer-motion";
import CalendarNotification from '../Header/CalendarNotification.jsx'

const AdminHeader = ({ setSelectedMonth, setSelectedYear, selectedMonth, selectedYear, selectedYear1, setSelectedYear1, selectedMonth1, setSelectedMonth1 }) => {
  const [adminData, setAdminData] = useState(localStorage.getItem("admindata"));
 
  // Sidebar collapsed 
  const [collapsed, setCollapsed] = useState(false);
  const [activeComponent, setActiveComponent] = useState("reservation");
  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const closeSidebar = () => {
    setCollapsed(false);

  };

  const style = {
    background: 'linear-gradient(var(--bg-color2), var(--bg-color1))',
    height: '100vh',
    transition: 'width 0.5s ease',
    width: collapsed ? '80px' : '200px',

  };
  const style1 = {
    background: 'linear-gradient(var(--bg-color2), var(--bg-color1))',
    height: '100vh',
    transition: 'width 0.5s ease',
    width: '200px',
  };

  const [searchQuery, setSearchQuery] = useState("");
  const [results, setResults] = useState([]);

  const handleSearch = () => {
    const mockData = ["Apple", "Banana", "Cherry", "Date", "Elderberry"];
    const filteredResults = mockData.filter((item) =>
      item.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setResults(filteredResults);
  };

  const location = useLocation();
  const isCalendarRoute = location.pathname.includes("calendar");


  useEffect(() => {
      const storedData = localStorage.getItem("admindata");
      if (storedData) {
          setAdminData(JSON.parse(storedData)); // Parse and store in state
      }
  }, []);
  
// console.log(results);

   


  return (
    <>
      {collapsed && <div className="overlay" onClick={closeSidebar}></div>}

      <main className={`main ${collapsed ? "collapsed" : ""} d-flex `}>
        <div className="d-md-block d-none ">
          <div className="side-navbar " style={style}>
            <ul className="list-unstyled">
              <li className="d-flex">
                <a href="/host/home" className="text-white d-flex align-items-center text-decoration-none">
                  <div>
                    <img src={require('../Assests/Logo.png')} className="mt-4 w-100" alt="Logo" />
                  </div>
                  <span className={`text pt-4 ms-2 d-flex justify-content-center ${collapsed ? "d-none" : ""}`}>
                    <h4>RideHire</h4>
                  </span>
                </a>
              </li>

              <li className="mt-3">
                <Link to={"/home"} className="text-decoration-none">
                  <span className="fs-4 text-white">
                    <IoHomeOutline />
                  </span>
                  <span className={`fs-6 ms-4 text-white ${collapsed ? "d-none" : ""}`}>Dashboard</span>
                </Link>
              </li>
              <li className="mt-2">
                <Link className="text-decoration-none">
                  <span className="fs-4 text-white">
                    <MdOutlineSpeakerNotes />
                  </span>
                  <span className={`fs-6 ms-4 text-white ${collapsed ? "d-none" : ""}`}>Request</span>
                </Link>
              </li>
              <li className="mt-2">
                <Link to={"/calendar"} className="text-decoration-none">
                  <span className="fs-4 text-white">
                    <MdEventAvailable />
                  </span>
                  <span className={`fs-6 ms-4 text-white ${collapsed ? "d-none" : ""}`}>Calendar</span>
                </Link>
              </li>
              <li className="mt-2">
                <Link className="text-decoration-none">
                  <span className="fs-4 text-white">
                    <IoMdNotificationsOutline />
                  </span>
                  <span className={`fs-6 ms-4 text-white ${collapsed ? "d-none" : ""}`}>Inbox</span>
                </Link>
              </li>
              <li className="mt-2">
                <Link className="text-decoration-none">
                  <span className="fs-4 text-white">
                    <BsChatDots />
                  </span>
                  <span className={`fs-6 ms-4 text-white ${collapsed ? "d-none" : ""}`}>Chats</span>
                </Link>
              </li>
              <li className="mt-2">
                <Link className="text-decoration-none">
                  <span className="fs-4 text-white">
                    <CgProfile />
                  </span>
                  <span className={`fs-6 ms-4 text-white ${collapsed ? "d-none" : ""}`}>Menu</span>
                </Link>
              </li>
              <li className="logout-btn">
                <Link className="text-decoration-none">
                  <span className={`fs-5 text-white d-flex justify-content-center ${collapsed ? "d-none" : ""}`}>Logout</span>
                </Link>
              </li>
            </ul>
          </div>
        </div>


        <div className={`content ${collapsed ? "collapsed" : ""} w-100 `}>
          <div className="top-navbar d-flex align-items-center justify-content-between postion-sticky py-2 px-3 ">
            <div className="d-flex align-items-center">
              <div
                className='d-md-block d-none' type="button"
                data-bs-toggle="offcanvas"
                role="button"
                data-bs-target="#offcanvasExample"
                aria-controls="offcanvasExample">

                {collapsed ? (
                  <BsBoxArrowInRight
                    className="bx fs-3" id="menu-icon" onClick={toggleSidebar}
                  />
                ) : (
                  <BsBoxArrowInLeft

                    className="bx fs-3" id="menu-icon" onClick={toggleSidebar}
                  />
                )}
              </div>

              <div className='d-flex d-md-none d-block align-items-center'>
                <img srcSet={require('../Assests/Logo.png')} className=" w-50" alt="Logo" />
                <button
                  className="btn p-0 text-white fs-5"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasExample"
                  aria-controls="offcanvasExample"
                >
                  <IoMenuSharp />
                </button>
                <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
                  <div className="offcanvas-header" style={style1}>
                    <div className="side-navbar" style={{ width: "200px" }}>
                      <ul className="list-unstyled">
                        <li className="d-flex align-items-center text-white">
                          <a href="/host/home" className="text-white d-flex align-items-center text-decoration-none">
                            <div>
                              <img srcSet={require('../Assests/Logo.png')} className="mt-4 w-100" alt="Logo" />
                            </div>
                            <span className="text pt-4 ms-2 d-flex justify-content-center">
                              <h3>RideHire</h3>
                            </span>
                          </a>
                        </li>
                        <li className="mt-3">
                          <Link to={"/home"} className="text-decoration-none">
                            <span className="fs-4 text-white"><IoHomeOutline /></span>
                            <span className="fs-6 ms-4 text-white">Dashboard</span> {/* Always visible */}
                          </Link>
                        </li>
                        <li className="mt-2">
                          <Link className="text-decoration-none">
                            <span className="fs-4 text-white"><MdOutlineSpeakerNotes /></span>
                            <span className="fs-6 ms-4 text-white">Request</span>
                          </Link>
                        </li>
                        <li className="mt-2">
                          <Link to={"/calendar"} className="text-decoration-none">
                            <span className="fs-4 text-white"><MdEventAvailable /></span>
                            <span className="fs-6 ms-4 text-white">Calendar</span>
                          </Link>
                        </li>
                        <li className="mt-2">
                          <Link className="text-decoration-none">
                            <span className="fs-4 text-white"><IoMdNotificationsOutline /></span>
                            <span className="fs-6 ms-4 text-white">Inbox</span>
                          </Link>
                        </li>
                        <li className="mt-2">
                          <Link className="text-decoration-none">
                            <span className="fs-4 text-white"><BsChatDots /></span>
                            <span className="fs-6 ms-4 text-white">Chats</span>
                          </Link>
                        </li>
                        <li className="mt-auto">
                          <Link className="text-decoration-none">
                            <span className="fs-6 text-white d-flex justify-content-center">Logout</span>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div >

              <div className="d-flex flex-column justify-content-center">
                {isCalendarRoute ? (
                  <h4 className="ms-3 d-none d-md-block m-0 logo-txt">Calendar</h4>
                ) : (
                  <h4 className="ms-3 d-none d-md-block m-0">Today</h4>
                )}

                <Header className="month-year  " selectedYear1={selectedYear1} setSelectedYear1={setSelectedYear1} selectedMonth1={selectedMonth1} setSelectedMonth1={setSelectedMonth1} activeComponent={activeComponent} setSelectedMonth={setSelectedMonth} setSelectedYear={setSelectedYear} searchQuery={searchQuery} setSearchQuery={setSearchQuery} handleSearch={handleSearch} />
              </div>


            </div >

            {isCalendarRoute && (
              <div className="toggle-container">
                <div className="toggle-buttons">
                  <motion.div
                    className="toggle-bg"
                    initial={{ x: "0%" }}
                    animate={{ x: activeComponent === "blockout" ? "90%" : "0%" }}
                    transition={{ type: "spring", stiffness: 300, damping: 20 }}
                  />
                  <button
                    className={activeComponent === "reservation" ? "active-btn" : ""}
                    onClick={() => setActiveComponent("reservation")}
                  >
                    Reservation
                  </button>
                  <button
                    className={activeComponent === "blockout" ? "active-btn" : ""}
                    onClick={() => setActiveComponent("blockout")}
                  >
                    Block Outs
                  </button>
                </div>
              </div>
            )}

            <div className="d-flex align-items-center">
              {/* < div className="notification-header position-relative" > */}
              {isCalendarRoute ? (
                <CalendarNotification />
              ) : (
                <IoIosNotifications className="fs-3" />

              )}
              {/* <span className="count position-absolute fs-6 d-flex align-items-center justify-content-center text-white">3</span>
              </div> */}

              <div className="dropdown d-flex align-items-center ms-3" >
              {adminData ? (
                <>
                <img
                  src={`https://ridehire-backend-2.onrender.com${adminData.admin_img}`}
                  className="profile-img"
                  data-bs-toggle="dropdown"
                  alt="Profile"
                  />
                <div className="ms-2 d-sm-block d-none" data-bs-toggle="dropdown" aria-expanded="false">
                  <h6>{adminData.admin_fName} {adminData.admin_lName}</h6>
                </div>
                  </>
                ) : (
                  <>
                   <img
                  src={"https://icons.veryicon.com/png/o/miscellaneous/youyinzhibo/guest.png"}
                  className="profile-img"
                  data-bs-toggle="dropdown"
                  alt="Profile"
                  />
                <div className="ms-2 d-sm-block d-none" data-bs-toggle="dropdown" aria-expanded="false">
                  <h6>Guest</h6>
                </div>
                  </>
              )}

                <ul className="dropdown-menu">
                  <li><button className="dropdown-item">Profile</button></li>
                  <li><button className="dropdown-item">Inbox</button></li>
                  <li><button className="dropdown-item">Settings</button></li>
                </ul>
              </div >
            </div >
          </div >
          {isCalendarRoute && (
            <div className="content-container">
              {activeComponent === "reservation" && <Calender selectedMonth={selectedMonth} selectedYear={selectedYear} />}
              {activeComponent === "blockout" && <Calender1 selectedMonth={selectedMonth1} selectedYear={selectedYear1} />}
            </div>
          )}

          <div>
            <Outlet />
          </div>
        </div>



      </main >
    </>
  )
}

export default AdminHeader
